import { useEffect, useState } from "react";
import usePost from "../../../hooks/usePost";
import { USER } from "../../../routes/routes_name";
import { useLocation } from "react-router-dom";
import usePut from "../../../hooks/usePut";

const UseFormUser = (props) => {
    const {
        isLoading,
        error,
        isSuccess,
        navigate,
        handlePost,
    } = usePost();
    const {
        isLoading: isLoadingPut,
        error: errorPut,
        isSuccess: isSuccessPut,
        navigate: navigatePut,
        handlePut,
    } = usePut();

    const location = useLocation();
    const [form, setForm] = useState({});

    useEffect(() => {
        if (props.type === 'post') {
            setForm({
                name: '',
                email: '',
                password: '',
                phone_number: '',
                height: '',
                weight: '',
                age: '',
            });
        } else {
            setForm({
                id: location.state._id,
                name: location.state.name,
                email: location.state.email,
                password: location.state.password,
                phone_number: location.state.phone_number,
                height: location.state.height,
                weight: location.state.weight,
                age: location.state.age,
            });
        }
    }, [props.type, location.state]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const data = {
            name: form['name'],
            email: form['email'],
            password: form['password'],
            phone_number: form['phone_number'],
            height: form['height'],
            weight: form['weight'],
            age: form['age'],
        };

        let params = {
            url: "/v1/user",
            form: data,
            navigation: USER,
            titleSuccess: 'Saved!',
            descSuccess: 'User data has been successfully saved.',
            type: 'application/json'
        };
        
        if (props.type === "post") {
            handlePost(params);
        } else {
            params.titleSuccess = 'Edited!';
            params.descSuccess = 'User data has been successfully edited.';
            params.url = `/v1/user?_id=${form["id"]}`;
            handlePut(params);
        }
    };

    const handleChange = (props) => {
        const { id, value } = props.target;
        setForm({
            ...form,
            [id]: value
        });
    };

    return {
        isLoading,
        isLoadingPut,
        form,
        handleChange,
        handleSubmit
    };
};

export default UseFormUser;
